<header
  aria-label="Main navigation header"
  class="ape-header flex items-center justify-start w-full h-[68px] gap-4 pr-6 bg-white shadow-[0px_0px_1px_0px_rgba(0,0,0,0.04),0px_2px_6px_0px_rgba(0,0,0,0.04),0px_10px_20px_0px_rgba(0,0,0,0.04)]"
  role="banner"
>
  <!-- Home Button -->
  <ape-header-home-button />

  <!-- Logo -->
  <div class="flex gap-[31px] items-center justify-start shrink-0">
    <ape-logo
      [route]="setRouteLogo()"
      [clickable]="true"
      variant="header"
    />
  </div>

  <!-- User Area -->
  <div class="flex items-center gap-[21px] justify-end flex-1">
    <ape-header-help-button (openSupportSidenav)="openSupportSidenav.emit()" />
    <ape-header-notification-button class="hidden sm:flex" (openSidenav)="openNotificationSidenav.emit()" />
    <div
      class="bg-[var(--colors-header-btn-primary)] box-border gap-1.5 items-center justify-start pl-[3px] pr-4 py-[3px] relative rounded-[46px] shrink-0 hidden lg:flex h-fit"
    >
      <ape-avatar
        [forename]="userFirstName"
        [image]="userAvatar"
        [surname]="userLastName"
        size="medium"
        variant="full"
      />
    </div>
    <ape-header-menu (openSupportSidenav)="openSupportSidenav.emit()" />
  </div>
</header>
